<script setup>
import { RouterView, useRoute } from "vue-router";
// import SideBar from "@/components/SideBar.vue"; // Sidebar dimatikan
import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import NavBar from "./components/NavBar.vue";
import { useAuthStore } from '@/stores/useAuthStore'
import Footer from "./components/Footer.vue";
import { usePermissionStore } from "./stores/usePermissionStore";
import { useMenuStore } from "@/stores/useMenuStore";

const route = useRoute();
const authStore = useAuthStore()
const perm = usePermissionStore();
const menuStore = useMenuStore();
const sidebarOpen = ref(true);
const isSidebarCollapsed = ref(false);

const isMobile = ref(window.innerWidth < 768);

const updateMobileStatus = () => {
  isMobile.value = window.innerWidth < 300;

  if (isMobile.value) {
    sidebarOpen.value = false;
  } else {
    sidebarOpen.value = true; 
  }
};


const toggleSidebar = () => {
  if (isMobile.value) {
    sidebarOpen.value = !sidebarOpen.value; 
  } else {
    isSidebarCollapsed.value = !isSidebarCollapsed.value; 
  }
};

const isLoginPage = computed(() => route.name === 'Login' || route.name === 'Register');

// onMounted(() => {
//   updateMobileStatus();
//   window.addEventListener("resize", updateMobileStatus);
//   authStore.initSession()
// });
// onMounted(async () => {

//   updateMobileStatus()
//   window.addEventListener("resize", updateMobileStatus)

//   // await authStore.initSession()

//   if (authStore.isAuthenticated && !perm.permissions.length && !perm.loading) {
//     await perm.fetchPermissions()
//   }
// })

onMounted(async () => {
  updateMobileStatus()
  window.addEventListener("resize", updateMobileStatus)

  // Tunggu initSession selesai
  await authStore.initSession()

  // Jika authenticated, fetch permissions & menu
  if (authStore.isLoggedIn) {
    console.log('[App] Fetching permissions & menu')
    await Promise.all([
      perm.fetchPermissions(),
      menuStore.fetchMenus()
    ])
  }
})

onUnmounted(() => {
  window.removeEventListener("resize", updateMobileStatus);
});


watch(isMobile, (newValue) => {
  sidebarOpen.value = !newValue; 
});
</script>

<!-- <template>
  <div class="flex">
    <NavBar v-if="!route.meta.fullpage" class="fixed top-0 w-full z-40" />
    
    <div
    :class="[
    'flex-1 min-h-screen transition-all',
    route.meta.noWrapperClass
      ? '' 
      : 'p-5 bg-gray-100 pt-[140px] lg:px-[30px]'
  ]"
>
<RouterView />
<div v-if="!isLoginPage" class="mt-20">
  <Footer />
</div>
</div>

  </div>
</template> -->

<template>
  <!-- Ubah ke flex-col agar anak-anaknya tersusun VERTICAL -->
  <div class="flex flex-col min-h-screen w-full">
    <!-- Navbar (tetap fixed di atas, tidak pengaruh ke footer) -->
    <NavBar v-if="!route.meta.fullpage" class="fixed top-0 w-full z-40" />

    <!-- Konten utama: hanya konten yang dapat padding & pt kompensasi navbar -->
    <main
      :class="[
        'flex-1 w-full transition-all',
        route.meta.noWrapperClass ? '' : 'p-5 bg-gray-100 pt-[140px] lg:px-[30px]'
      ]"
    >
      <RouterView />
    </main>

    <!-- Footer dipisah, tidak kena padding konten -->
    <Footer v-if="!isLoginPage" class="w-full shadow-lg" />
  </div>
</template>


<!-- Sidebar Dimatikan -->
<!--
<SideBar
  v-if="!route.meta.fullpage"
  :sidebarOpen="sidebarOpen"
  :isSidebarCollapsed="isSidebarCollapsed"
  @toggle="toggleSidebar"
/>
-->

<!-- Overlay Mobile Dimatikan -->
<!--
<div
  v-if="sidebarOpen && isMobile"
  @click="toggleSidebar"
  class="fixed inset-0 bg-black bg-opacity-50 z-30 sm:hidden"
></div>
-->

<!-- Konten utama -->
<!-- <div
  class="flex-1 min-h-screen p-5 transition-all bg-gray-100 pt-[140px] lg:px-[30px]"
>
  <RouterView />
</div> -->